import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  good: false,
  lastCheck: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_AUTH_PING:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_AUTH_PING:
      const good = !action.error;
      return {
        ...state,
        isLoading: false,
        good,
        lastCheck: Date.now()
      };
    default:
      return state;
  }
}
